// 分页数据
export const PagingData = {
  data() {
    return {
      pagingData: {
        total: 0,
        pageSize: 10,
        pageList: [10, 20, 50, 100, 200, 500],
        currentPage: 1,
      }
    }
  }
};
